import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot } from "vue";
import _imports_0 from '../../assets/close-24px.svg';
import _imports_1 from '../../assets/WhatsappPromo.png';
const _hoisted_1 = { class: "whatsapp-promo-card" };
const _hoisted_2 = {
    key: 1,
    src: _imports_1,
    alt: "WhatsApp",
    class: "promo-image"
};
const _hoisted_3 = { class: "card-title" };
const _hoisted_4 = { class: "card-subtitle" };
const _hoisted_5 = {
    key: 2,
    class: "sent-message"
};
import { ref } from 'vue';
import MGButton from './MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WhatsAppPromoCard',
    props: {
        title: { default: 'Send a document or photo' },
        subtitle: { default: "We'll add the key details and save the document securely. You can also chat with our WhatsApp assistant." },
        buttonText: { default: 'Add via WhatsApp' },
        showImage: { type: Boolean, default: false },
        closable: { type: Boolean, default: true }
    },
    emits: ["close", "action"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const emit = __emit;
        const clicked = ref(false);
        function handleClick() {
            if (!clicked.value) {
                emit('action');
                clicked.value = true;
                setTimeout(() => {
                    clicked.value = false;
                }, 10000);
            }
        }
        function setClicked() {
            clicked.value = true;
        }
        function reset() {
            clicked.value = false;
        }
        __expose({ setClicked, reset });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.closable)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "close-button",
                        onClick: _cache[0] || (_cache[0] = ($event) => (emit('close')))
                    }, _cache[1] || (_cache[1] = [
                        _createElementVNode("img", {
                            src: _imports_0,
                            alt: "Close"
                        }, null, -1)
                    ])))
                    : _createCommentVNode("", true),
                (_ctx.showImage)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.subtitle), 1),
                _createVNode(MGButton, {
                    text: _ctx.buttonText,
                    icon: require('@/assets/whatsapp.png'),
                    leftIconSize: 20,
                    arrow: true,
                    disabled: clicked.value,
                    fullWidth: true,
                    backgroundColor: 'var(--whatsapp-green)',
                    onClick: handleClick
                }, null, 8, ["text", "icon", "disabled"]),
                _renderSlot(_ctx.$slots, "default"),
                (clicked.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, "We've sent you a message, please check your WhatsApp messages."))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
